import * as React from 'react'
import styled from 'styled-components'
import I18n from '../../../../core/i18n'
import { IJsonResponse } from '../../../../core/JsonApiSerializer'
import { adminService } from '../../../../core/services'
import * as interfaces from '../../../../static/interfaces'
import * as Hooks from '../../../../utils/hooks'
import { Button } from '../../../atoms'
import AdminLayoutIndex from '../_layouts'
import { Container, Draggable } from 'react-smooth-dnd'
import arrayMove from 'array-move'
import * as constants from '../../../../static/constants'
import SvgIcon from 'components/atoms/SvgIcon'

declare var window: interfaces.IWindow

interface IProps {
  features: {
    features: IJsonResponse
  }
  tags: IJsonResponse
  categories: IJsonResponse
  areas: IJsonResponse
}

const AdminFeatureIndex: React.FC<IProps> = props => {
  Hooks.SetDocumentTitle('Admin feature')
  const { data } = adminService.getDataFromJson(props.features.features)

  const [features, setFeatures] = React.useState(data)

  const onDrop = ({ removedIndex, addedIndex }) => {
    setFeatures(old => arrayMove(old, removedIndex, addedIndex))
  }

  const onSubmit = () => {
    updateFeaturesOrder()
  }

  const updateFeaturesOrder = React.useCallback(async () => {
    const features_ids = features.map(item => {
      return item.id
    })
    const { updatedFeatures, flush } = await adminService.updateFeatures(features_ids)
    window.flashMessages.addMessage({ text: flush.message, type: flush.type })
    location.href = '/admin/features'
  }, [features])

  const handleDelete = React.useCallback(
    async id => {
      const { flush } = await adminService.deleteFeature(id)
      // TODO 成功レスポンスと揃えたい
      window.flashMessages.addMessage({
        text: flush.message,
        type: flush.type,
      })
      setFeatures(features.filter(feature => feature.id !== id))
    },
    [features]
  )

  const handleClickDelete = id => {
    if (window.confirm(I18n.t('generic.delete_confirmation'))) {
      handleDelete(id)
    }
  }

  return (
    <AdminLayoutIndex
      model="feature"
      title={
        <Heading>
          <span>{I18n.t('generic.features')}</span>
          <Button small={true}>
            <a href="/admin/features/new">{I18n.t('generic.create_new')}</a>
          </Button>
        </Heading>
      }
      main={
        <DraggableTable>
          <div className="Table">
            <div>
              <div className="Table_Row">
                <div className="Table_Header">{I18n.t('generic.id')}</div>
                <div className="Table_Header label">{I18n.t('generic.title')}</div>
                <div className="Table_Header label">Slug</div>
                <div className="Table_Header">Parent</div>
                <div className="Table_Header">Type</div>
                <div className="Table_Header" />
                <div className="Table_Header handle" />
              </div>
            </div>
            <div>
              <Container onDrop={onDrop}>
                {features.map((feature, index) => {
                  return (
                    <Draggable key={`feature-${index}`}>
                      <div className="Table_Row">
                        <div className="Table_Data">{feature.id}</div>
                        <div className="Table_Data label">{feature.title}</div>
                        <div className="Table_Data label">{feature.slug}</div>
                        <div className="Table_Data">
                          {feature.is_parent ? (
                            <SvgIcon
                              name="check"
                              color={constants.COLORS.primary}
                              className="icon"
                              ariaHidden={true}
                              role="presentation"
                            />
                          ) : null}
                        </div>
                        <div className="Table_Data">{feature.feature_type}</div>
                        <div className="Table_Data">
                          <Button small={true}>
                            <a href={`/admin/features/${feature.id}/edit`}>
                              {I18n.t('generic.edit')}
                            </a>
                          </Button>
                          <Button
                            small={true}
                            handleClick={() => {
                              handleClickDelete(feature.id)
                            }}
                          >
                            {I18n.t('generic.delete')}
                          </Button>
                        </div>
                        <div className="Table_Data handle">
                          <SvgIcon
                            name="drag_handle"
                            className="icon"
                            ariaHidden={true}
                            role="presentation"
                          />
                        </div>
                      </div>
                    </Draggable>
                  )
                })}
              </Container>
            </div>
          </div>
          <Button handleClick={onSubmit}>{I18n.t('generic.update_order')}</Button>
        </DraggableTable>
      }
    />
  )
}

const Heading = styled.div`
  .Button {
    margin-left: 12px;
  }
`

const DraggableTable = styled.div`
  .Table {
    display: table;
    margin-bottom: 20px;
    .Table_Header,
    .Table_Data {
      display: table-cell;
      max-width: 240px;
      width: 120px;
      height: 40px;
      padding: 4px 8px;
      vertical-align: middle;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      border-bottom: solid 1px ${constants.COLORS.divider};
      &.handle {
        cursor: grab;
        &:active {
          cursor: grabbing;
        }
      }
      > a {
        color: ${constants.COLORS.primary};
      }
      &.label {
        width: 240px;
      }
      &.handle {
        width: 40px;
        text-align: center;
      }
    }
  }
`
export default AdminFeatureIndex
